var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "var(--primary)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7072 8.90112L9.78193 14.8264C8.66418 15.9441 7.19596 16.5029 5.72774 16.5029C4.25952 16.5029 2.79137 15.9441 1.67365 14.8264C-0.561789 12.5909 -0.561789 8.95352 1.67365 6.71809L6.67849 1.71327C8.29877 0.092961 10.9351 0.0929922 12.5554 1.71324C14.1757 3.33359 14.1757 5.96996 12.5554 7.59021L7.65843 12.4871C6.65337 13.4923 5.01796 13.4922 4.01287 12.4872C3.00777 11.4821 3.00777 9.84671 4.01284 8.84162L8.88412 3.9703C9.27465 3.5798 9.9078 3.5798 10.2983 3.9703C10.6889 4.36084 10.6889 4.99402 10.2983 5.38455L5.42709 10.2558C5.20562 10.4773 5.20562 10.8515 5.42709 11.0729C5.64855 11.2944 6.02277 11.2944 6.24421 11.0729L11.1412 6.17596C11.9817 5.33546 11.9817 3.96793 11.1412 3.12743C10.3007 2.28696 8.93315 2.28693 8.09268 3.12746L3.0879 8.13227C1.63224 9.58796 1.63224 11.9565 3.0879 13.4122C4.54355 14.8678 6.91209 14.8678 8.36774 13.4121L14.293 7.48687C14.6836 7.0964 15.3167 7.0963 15.7072 7.4869C16.0978 7.8774 16.0977 8.51059 15.7072 8.90112Z",
    fill: "var(--primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileSvg);
export default __webpack_public_path__ + "static/media/attachFileSVG.d590793c82cbc7ff44a9966db72304e4.svg";
export { ForwardRef as ReactComponent };